<template>
  <div>
    <validation-observer ref="templateValidations">
      <section>
        <b-form-group :label="$t('contract.header')">
          <b-form-textarea v-model="document.header" />
        </b-form-group>
        <b-form-group :label="$t('contract.main_part')">
          <quill-editor
            v-model="document.main_part"
            :options="editorOption"
            class="mb-1"
          />
        </b-form-group>
      </section>
      <section
        v-for="(clause, index) in document.clauses"
        :key="index"
      >
        <b-row>
          <b-col
            class="pl-0"
            offset="1"
            md="10"
          >
            <b-form-group :label="$t('contract.clause_name')">
              <b-input-group>
                <b-input-group-prepend is-text>
                  {{ index + 1 }}
                </b-input-group-prepend>
                <b-form-input
                  v-model="clause.title"
                  :placeholder="$t('contract.clause_name')"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col
            class="pl-0"
            md="1"
          >
            <b-button
              class="mt-1 px-50"
              variant="primary"
              @click="addClause(index)"
            >
              <!-- <feather-icon icon="PlusIcon" /> -->
              {{ $t('contract.add_clause') }}
            </b-button>
            <b-button
              variant="danger"
              class="px-50"
              @click="removeClause(index)"
            >
              <!-- <feather-icon icon="TrashIcon" /> -->
              {{ $t('contract.delete_clause') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row
          v-for="(subclause, ind) in clause.subclauses"
          :key="ind"
        >
          <b-col md="1">
            <b-form-group :label="$t('contract.subclause')+':'">
              <b-form-input v-model="subclause.key" />
            </b-form-group>
          </b-col>
          <b-col
            class="pl-0"
            md="10"
          >
            <b-form-group
              class=""
              :label="$t('contract.content')"
            >
              <quill-editor
                v-model="subclause.value"
                :options="editorOption"
                placeholder=""
                class="mb-1"
              />
            </b-form-group>
          </b-col>
          <b-col
            class="pl-0"
            md="1"
          >
            <b-form-group class="mt-2">
              <div class="d-flex flex-column align-items-center">
                <b-button
                  class="mb-1 px-75"
                  variant="danger"
                  @click="removeSubclause(ind, index)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
                <b-button
                  class="px-50"
                  @click="addSubClause(ind, index)"
                >
                  {{ $t('contract.add_subclause') }}
                </b-button>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
      </section>
      <b-button
        v-if="document.clauses.length"
        variant="primary"
        class="mb-1 mx-auto"
        @click="addClause()"
      >
        {{ $t('contract.add_clause') }}
      </b-button>

    </validation-observer>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BFormGroup, BFormTextarea, BFormInput, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import {
  ValidationObserver,
} from 'vee-validate'
import { quillEditor } from 'vue-quill-editor'
import { required } from '@validations'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import formatters from '@/mixins/extra'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    FeatherIcon,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    ValidationObserver,
    quillEditor,
  },
  mixins: [formatters],
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    client: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
    documentSubject: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      document: {
        header: '',
        main_part: '',
        clauses: [
          {
            title: '',
            subclauses: [
              {},
            ],
          },
        ],
      },
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
          ],
        },
      },
      required,
    }
  },
  computed: {
    ...mapGetters('contracts', ['GET_ONE_CONTRACT']),
  },
  watch: {
    documentSubject() {
      this.document = this.documentSubject
    },
  },
  mounted() {
    this.document = this.documentSubject
  },
  methods: {
    ...mapActions('contracts', ['ADD_CONTRACT', 'EDIT_CONTRACT', 'FETCH_ONE_CONTRACT', 'DOWNLOAD_CONTRACT_PDF']),
    saveClick() {
      this.$refs.templateValidations.validate().then(success => {
        if (success) {
          console.log(this.docuemnt)
          this.$emit('saveClick', this.docuemnt)
        }
      })
    },
    addClause(clause_index) {
      if (clause_index) {
        this.document.clauses.splice(clause_index + 1, 0, { subclauses: [{}], title: '' })
      } else {
        this.document.clauses.push({ subclauses: [{}], title: '' })
      }
    },
    removeClause(clause_index) {
      this.document.clauses.splice(clause_index, 1)
    },
    addSubClause(subclause_index, clause_index) {
      this.document.clauses[clause_index].subclauses.splice(subclause_index + 1, 0, {})
    },
    removeSubclause(subclause_index, clause_index) {
      this.document.clauses[clause_index].subclauses.splice(subclause_index, 1)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.clients-select-contracts-loader {
  text-align: center;
  color: #bbbbbb;
}
.clients-select-contracts ul {
  max-height: 200px;
}
</style>
